/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceDto } from '../../models/client-workspace-dto';

export interface ClientWorkspaceControllerFindByIdWithVendorWorkspaceId$Params {
  id: string;
  vendorWorkspaceId: string;
}

export function clientWorkspaceControllerFindByIdWithVendorWorkspaceId(http: HttpClient, rootUrl: string, params: ClientWorkspaceControllerFindByIdWithVendorWorkspaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceControllerFindByIdWithVendorWorkspaceId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('vendorWorkspaceId', params.vendorWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceDto>;
    })
  );
}

clientWorkspaceControllerFindByIdWithVendorWorkspaceId.PATH = '/api/clientWorkspace/{id}/{vendorWorkspaceId}/vendor';
